import { render, staticRenderFns } from "./SingInAnimation.vue?vue&type=template&id=4220b499&scoped=true"
import script from "./SingInAnimation.vue?vue&type=script&lang=js"
export * from "./SingInAnimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4220b499",
  null
  
)

export default component.exports